import { useOuraData } from "../contexts/OuraDataContext";

/**
 * WHAT:
 *   Optimized Full Sleep Hook using centralized data context.
 *
 * WHY:
 *   Uses centralized data context instead of making separate API calls.
 *
 * @returns Object containing full sleep data, heart rate, HRV measurements, and loading state
 *
 */
export const useOptimizedFullSleep = () => {
  const {
    averageHeartRate,
    averageHRV,
    error,
    fullSleep,
    heartRateMeasurements,
    hrvMeasurements,
    loading,
    maxHRV,
  } = useOuraData();

  return {
    averageHeartRate,
    averageHRV,
    error,
    fullSleep,
    heartRateMeasurements,
    hrvMeasurements,
    loading,
    maxHRV,
  };
};
